import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';

@Component({
  selector: 'app-callback-shopify',
  templateUrl: './callback-shopify.component.html',
  styleUrls: ['./callback-shopify.component.scss'],
})
export class CallbackShopifyComponent implements OnInit {
  public broadcastChannel = new BroadcastChannel('SHOPIFY_CHANNEL');

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
  ) {}

  ngOnInit() {
    let PartnerID = localStorage.getItem('ShopifyPartnerID');
    this.activatedRoute.queryParams.subscribe((params) => {
      var data = {
        PartnerID: PartnerID,
        ShopURLName: params['shop'],
        Token: params['code'],
      };
      this.posIntegrationService.registerShopify(data).subscribe(
        (result) => {
          console.log(result);
          this.broadcastChannel.postMessage('CONNECTED');
          setTimeout(() => {
            window.close();
          }, 500);
        },
        (err) => {
          this.broadcastChannel.postMessage('NOT_CONNECTED');
          window.close();
        },
      );
    });
  }
}
